import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import * as api from "lib/api";
import API_RESOURCES from "lib/api/resources";

import ScreenLayout from "components/ScreenLayout";
import CategoriesGridList from "screens/Categories/components/CategoriesGridList";
import CategoriesTable from "screens/Categories/components/CategoriesTable";
import catogoriesHeaderComponents from "screens/Categories/components/catogoriesHeaderComponents";

import { fetchCategories, unsetSelectedCategory } from "store/category/actions";
import { resetClientFilterInitialized } from "store/helper/actions";

import "./styles.scss";

const Categories = () => {
  const location = useLocation();
  const searchParams = queryString.parse(location.search);

  const { selectedDisplayList } = useSelector(
    ({ categoryReducer }) => categoryReducer
  );

  const { messagePayload, clientFilterInitialized } = useSelector(({ helperReducer }) => helperReducer);

  const dispatch = useDispatch();
  const hasReset = useRef(false);
  const lastPathname = useRef('');
  const [userClientCount, setUserClientCount] = useState(null);
  
  useEffect(() => {
    if (!hasReset.current || lastPathname.current !== location.pathname) {
      dispatch(unsetSelectedCategory());
      dispatch(resetClientFilterInitialized());
      hasReset.current = true;
      lastPathname.current = location.pathname;
      setUserClientCount(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await api.get(`${API_RESOURCES.USER_CLIENT_ROLES}/by-user/me`);
        
        if (response && response.data) {
          const assignments = response.data.assignments || [];
          const activeClientRoles = assignments.filter(a => a.client && a.client.status === 'active');
          setUserClientCount(activeClientRoles.length);
        } else {
          setUserClientCount(0);
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
        setUserClientCount(0);
      }
    };

    if (!userClientCount && clientFilterInitialized) {
      fetchUserInfo();
    }
  }, [clientFilterInitialized, userClientCount]);

  useEffect(() => {
    if (!hasReset.current) return;
    if (!clientFilterInitialized) return;
    if (userClientCount === null) return;
    
    if (userClientCount === 1 && Object.keys(searchParams || {}).length === 0) {
      return;
    }
    
    dispatch(fetchCategories(searchParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, clientFilterInitialized, userClientCount]);

  useEffect(() => {
    if (messagePayload) {
      dispatch(fetchCategories(searchParams));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagePayload]);

  return (
    <ScreenLayout headerComponents={catogoriesHeaderComponents}>
      {selectedDisplayList === "grid" ? (
        <CategoriesGridList />
      ) : (
          <CategoriesTable />
        )}

    </ScreenLayout>
  );
};

export default Categories;
